import React from "react";
import axios from 'axios';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { connect } from "react-redux";
import history from "../../auth/history";
import '../MoneyTransferComponent/MoneyTransfer.css';
import swal from 'sweetalert';
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import { selectedRechargableAmnt, selectedRechargableAmnt1, setAmount, setAmount1, setCreateOrderRes, setCreateOrderRes1, setCreteOrderReq1, setMoneyTransferSurChargeAmount, setMoneyTransferSurChargeAmount1, setMoneyTransferTotalAmount1, setOrderId1 } from "../../redux/recharge/recharge.action";
import { setMoneyTransferTotalAmount } from "../../redux/misc-data/misc-data.action";
import { showCreateOrderResponse, showCreateOrderResponse1, showCreateOrderResponseArr } from '../../redux/response/response.action';
import ProgresStatic from '../../assests/images/mtimg.png';
import Avatar from 'react-avatar';
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import ProgressGif from '../../assests/images/progress.gif';
import FooterComponet from "../FooterComponent/FooterComponet";
import { TimeScale } from "chart.js";
import tokenErrorHandler from "../tokenErrorHandler";

const httpClient = axios.create();
class RechargeMoneyTransfer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			amount: 0,
			statusEnquiryAttempCount: 0,
			createOrderResponseArr: [],
			currentRequestId: null,
			progressStatus: false,
			orderprocessing: '',
			originalAmout: '',
			orderAmount: '',
			calculatePricingFiledLock: false,

			displayErrorMsg: '',
			transfernowBtnBlock: false,
			moneyTransferEnable: true,
			showStatusModal: false,
			displayStatusMsg: '',
			progress: '',
			rechargeStatus:''
		}
	}



	calculatePricing() {

		this.setState({
			displayErrorMsg: ''
		})
		store.dispatch(setMoneyTransferTotalAmount1(''));
		store.dispatch(setMoneyTransferSurChargeAmount1(''));
		store.dispatch(showCreateOrderResponse1(''));
		store.dispatch(setOrderId1(''));
		store.dispatch(setAmount1(''));




		const header = {
			msgType: "CALCULATE_PRICING",
			service: "PRICING",
			// dstService:"CUSTOM_SERVICE",
			channel: "ADMIN",
			requesterId: this.props.clientRequesterId,
			requestId: uuidv4(),//filled by the 3rd party requester
			time: moment().utc(),
			traceId: uuidv4(),
		}

		var pricingUrl = '/api/v1/pricing/calculate';



		const pricingReq = {
			header: header,
			entityId: this.props.agentInfo.id,
			entityType: "RETAILER",
			productTree:
			{
				serviceCode: "VAS",
				categoryCode: this.props.rechargeType.toUpperCase(),
				productCode: this.props.selectedOperator
			},
			txnAmount: parseFloat(this.props.rechargeAmount1).toFixed(2)

		}
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		console.log('pricing req:' + JSON.stringify(pricingReq));

		httpClient.post(pricingUrl, pricingReq, {
			timeout: 60 * 1000,
			timeoutErrorMessage: 'timeout',
			headers
		}
		).then((response) => {
			this.setState({
				progressStatus: false,
				calculatePricingFiledLock: true

			})

			console.log('pricing response' + JSON.stringify(response.data));
			if (response.data.response.msg == 'SUCCESS') {

				console.log('pricing service response:' + JSON.stringify(response.data))
				store.dispatch(setAmount1(this.props.rechargeAmount1));
				var totalAmount = parseInt(response.data.txnAmount) +
					parseInt(response.data.pricingAmount);
				store.dispatch(setMoneyTransferTotalAmount1(totalAmount));
				store.dispatch(setMoneyTransferSurChargeAmount1(response.data.pricingAmount));
				store.dispatch(showCreateOrderResponse1(response.data));
				store.dispatch(setOrderId1(response.data.pricingId));

				this.setState({
					transfernowBtnBlock: true
				})

			} else {
				this.setState({
					rechargeStatus:'failed'
				})
				this.errorMessageCall(response.data.response.displayMsg);
			}
		}).catch(error => {
			this.setState({
				progressStatus: false
			})
			this.setState({
				rechargeStatus:'failed'
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			} else if(error.message.includes("timeout")){
				this.errorMessageCall('Request timed out.');
			}else{
				this.errorMessageCall(error.message);
			}
		})
	}




	errorMessageCall = (message) => {
		this.setState({
			displayErrorMsg: message
		})
	}




	componentDidMount() {
		store.dispatch(setMoneyTransferTotalAmount1(''));
		store.dispatch(setMoneyTransferSurChargeAmount1(''));

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}
		this.calculatePricing();
	}

	componentWillUnmount() {
	}

	handleClose = (event) => {
		event.preventDefault();
		this.setState({
			showStatusModal: false
		})
	}


	enterAmount = (event) => {
		this.setState({
			orderAmount: event.target.value
		})
	}
	createOrder = (event) => {
		event.preventDefault();

		this.setState({
			displayErrorMsg:'',
			progress: 'start',
			orderprocessing: 'start',
			transfernowBtnBlock: false,
			rechargeStatus:''
		});

		var header = '';
		if (this.props.rechargeType == 'mobile') {
			header = {
				msgType: "CREATE_ORDER",
				service: "MOBILE",
				channel: "WHITELABEL",
				requesterId: this.props.clientRequesterId,
				requestId: uuidv4(),
				time: moment().utc(),
			}
		}
		if (this.props.rechargeType == 'dth') {
			header = {
				msgType: "CREATE_ORDER",
				service: "DTH",
				channel: "WHITELABEL",
				requesterId: this.props.clientRequesterId,
				requestId: uuidv4(),
				time: moment().utc(),
			}
		}

		var transaction = '';
		if (this.props.rechargeType == 'mobile') {
			transaction = {
				mobile: this.props.rechargeMobileNo,
				amount: parseFloat(this.props.rechargeAmount1).toFixed(2),
				operator: this.props.selectedOperator,
				CIRCLE: this.props.selectedCircle,
				operator_code: ''
			}
		}

		if (this.props.rechargeType == 'dth') {
			transaction = {
				amount: parseFloat(this.props.rechargeAmount1).toFixed(2),
				operator: this.props.selectedOperator,
				customerId: this.props.dthCustomerId,
				operator_code: ''
			}
		}


		var createOrderRequest = '';
		if (this.props.rechargeType == 'mobile') {
			createOrderRequest = {
				header: header,
				device: this.props.deviceInfo,
				transaction: transaction,
				validated: true,
				payment: "PARTNER_BALANCE",
				agentId: this.props.agentInfo.id,

			}
		}
		if (this.props.rechargeType == 'dth') {
			createOrderRequest = {
				header: header,
				device: this.props.deviceInfo,
				transaction: transaction,
				validated: true,
				payment: "PARTNER_BALANCE",
				agentId: this.props.agentInfo.id,
			}
		}



		var createOrderUrl = '';
		if (this.props.rechargeType == 'mobile') {
			createOrderUrl = '/api/v1/proxy/mobile/order/create';
		}
		if (this.props.rechargeType == 'dth') {
			createOrderUrl = '/api/v1/dth/order/create';
		}

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}

		console.log('create order req:' + JSON.stringify(createOrderRequest));

		httpClient.post(createOrderUrl, createOrderRequest, {
			timeout: 90 * 1000,
			timeoutErrorMessage: 'timeout',
			headers
		}
		).then((response) => {


			console.log('create order response' + JSON.stringify(response.data));
			if (response.data.response.success == true
				//&& response.data.response.msg == 'SUCCESS'
			) {

				this.setState({
					progress: 'finished',
					orderprocessing: 'end',
				})

				store.dispatch(setCreteOrderReq1(createOrderRequest));
				store.dispatch(setCreateOrderRes1(response.data));
				store.dispatch(setMoneyTransferTotalAmount1(this.props.rechargeAmount1));

				var gotomoneytransferDetails = document.getElementById('gotomoneytransferDetails');
				gotomoneytransferDetails.click();

			} else {
				this.setState({
					progress: 'finished',
					orderprocessing: 'end',
					transfernowBtnBlock: true
				})
				this.setState({
					rechargeStatus:'failed'
				})
				

			}
		}).catch(error => {
			this.setState({
				progress: 'finished',
				orderprocessing: 'end',
				transfernowBtnBlock: true
			})
			this.setState({
				progressStatus: false
			})
			this.setState({
				rechargeStatus:'failed'
			})

			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			} else if(error.message.includes("timeout")){
				this.errorMessageCall('Transaction under process,successful');
			}else{
				this.errorMessageCall(error.message);
			}

			
			// if (error.message.includes("401")) {
			// 	tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			// } else {

			// }
		})
	}





	render() {

		return (

			<div>
				<HeadeCommon />
				<Menu />
				<div class="main">
					<Link to='/recharge-details'>
						<button id='gotomoneytransferDetails' hidden={true}></button>
					</Link>
					<div class="right-side">
						<div class="container-fluid">
							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">

										<div class="head">
											<h3>Recharge</h3>
											<Link to='/recharge'>
												<button class="dbbtn" type="button">Back</button>
											</Link>
										</div>
										<div class="benedtls">
											<div class="row justify-content-md-center">
												<div class="col-12 col-md-6 col-lg-4 order-lg-1">
													<div class="graycard">
														<div class="bankdtl">
															{/* <Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" /> */}
															<h5>Operator Name</h5>
															<p>{this.props.selectedOperator}</p>
														</div>
														<hr />
														<div class="bankdtl">
															<h5>Mobile Number</h5>
															<p>{this.props.rechargeMobileNo}</p>
														</div>
													</div>
												</div>

												<div class="col-12 col-md-6 col-lg-4 order-lg-3">
													<div class="graycard">
														<div class="bankdtl">
															<h5>Retailer Id</h5>
															<p>{this.props.agentInfo.id}</p>
														</div>
														<hr />
														<div class="acntifsc">
															<h5>Retailer Name</h5>
															<p>{this.props.agentInfo.kioskName}</p>
														</div>

														<div class="acntifsc rtxt">
															<h5>Kiosk Code</h5>
															<p>{this.props.agentInfo.kioskCode}</p>
														</div>
													</div>
												</div>

												<div class="col-12 col-lg-4 order-lg-2">
													{(this.state.progress == 'start') &&
														<div class="mtprogess d-none d-md-block">
															<img src={ProgressGif} alt="process" class="img-fluid" />
														</div>
													}
													{(this.state.progress == 'finished' ||
														this.state.progress == '') &&
														<div class="mtprogess d-none d-md-block">
															<img src={ProgresStatic} alt="process" class="img-fluid" />
														</div>
													}

													<div class="form-floating input-group amtmrgn">

														<input type="number" class="form-control" id="amt" placeholder="Amount"
															value={this.props.rechargeAmount1}

															readOnly />

														<label for="amt">Recharge Amount</label>

														{this.state.transfernowBtnBlock == true &&
															<button type="button" class="btn btnmtr"
																onClick={(e) => this.createOrder(e)}
															>{this.state.rechargeStatus == 'failed' ? 'Retry' : 'Recharge'}</button>
														}
														{this.state.transfernowBtnBlock == false &&
															this.state.orderprocessing == 'start' &&
															<button type="button" disabled class="btn btnmtr"
															>Recharge</button>
														}

														{this.state.transfernowBtnBlock == false &&
															this.state.orderprocessing == 'end' &&
															<button type="button" class="btn btnmtr"
																onClick={(e) => this.createOrder(e)}
															>Recharge</button>
														}

														{this.state.transfernowBtnBlock == false &&
															this.state.orderprocessing == '' &&
															<button type="button" disabled class="btn btnmtr"
															>Recharge</button>
														}



														{this.state.displayErrorMsg != '' &&
															<div class='valid-error'>
																{this.state.displayErrorMsg}
															</div>}
													</div>
													{this.state.rechargeStatus == 'failed' &&
														<Link to='/recharge'>
															<button class="dbbtn" type="button">Back to Recharge Page</button>
														</Link>}
													
													{(this.props.surcharge1 != '' && this.props.transferTotalAmount1 != ''
														&& this.props.rechargeAmount1 != '') &&
														<div class="amtshow"
														>
															<div class="amntchrg">
																<p>Comission</p>
																<h5>₹ {this.props.surcharge1}</h5>
															</div>
															<div class="dbtamt">
																<p>Total Amount</p>
																<h4>₹{parseFloat(this.props.rechargeAmount1) -
																	parseFloat(this.props.surcharge1)}</h4>

															</div>
														</div>
													}


												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<FooterComponet />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone,
			agentInfo, token, clientRole, clientRequesterId, deviceInfo, callBackUrl }
		, rechargeReduce: { surcharge1,
			transferTotalAmount1,
			customerId, rechargeAmount1, rechargeMobileNo, selectedOperator, selectedCircle, dthCustomerId, rechargeType } }
) => ({
	errorMessage, loginErrorMessage, phone,
	agentInfo, token, clientRole, clientRequesterId, deviceInfo, callBackUrl,
	surcharge1,
	transferTotalAmount1,
	customerId, rechargeAmount1, rechargeMobileNo, selectedOperator, selectedCircle, dthCustomerId, rechargeType
});

export default connect(mapStateToProps, null)(RechargeMoneyTransfer);

